module.exports = __webpack_public_path__ + "img/5.64ca002d.png";